<script setup>
import { ref } from 'vue'
import { useGlobalStore } from '@stores/global'
import Button from '@components/global/button.vue'
import Input from '@components/global/input.vue'
import Textarea from '@components/global/textarea.vue'

const global = useGlobalStore()
const processing = ref(false)
const success = ref(false)
const inquiry = ref({})
const errors = ref({})

function submit(form) {
	form.preventDefault()
	if (!processing.value) {
		processing.value = true
		axios
			.post('/api/inquiry', inquiry.value)
			.then(() => {
				errors.value = {}
				processing.value = false
				success.value = true
			})
			.catch((error) => {
				console.error(error)
				processing.value = false
				success.value = false
				if (error.response.status === 422) errors.value = error.response.data.errors
			})
	}
}
</script>
<template>
	<section class="container flex flex-col gap-6 lg:flex-row">
		<div class="flex w-full flex-col rounded-2xl bg-bgAccent p-8 lg:p-14">
			<div class="flex flex-col gap-4">
				<span class="h9">Contact Us</span>
				<h2 class="mt-2">Let's talk</h2>
				<span class="">Get in touch with us for any questions or assistance.</span>
				<div class="mt-10 flex max-w-[200px] flex-row flex-wrap gap-2">
					<a v-for="social in global.socials" :key="social.avatar_url" :href="social.link" :title="`${social.platform.name} - ${social.username}`" target="_blank" class="flex h-4 w-4 items-center justify-center rounded-full border border-border bg-bgMain p-5 leading-[100%]">
						<i :class="social.platform.icon" />
					</a>
				</div>
			</div>
			<div class="flex-1"></div>
			<div class="mt-4 flex flex-col gap-4">
				<div v-for="contact of global.contacts" class="flex items-center gap-2">
					<i :class="contact.icon" />
					{{ contact.label }}
				</div>
			</div>
		</div>
		<div class="grid w-full grid-cols-1 gap-4 rounded-2xl bg-bgSecondary p-8 font-medium lg:p-14" v-if="success">Thank you, we will get back to you as soon as possible.</div>
		<form class="grid w-full grid-cols-1 gap-4 rounded-2xl bg-bgSecondary p-8 md:grid-cols-2 lg:p-14" @submit="submit" v-else>
			<Input placeholder="Insert your first name here" label="First name" class="col-span-2 md:col-span-1" autocomplete="given-name" :required="true" v-model="inquiry.first_name" :error="errors.first_name && errors.first_name[0]" />
			<Input placeholder="Insert your last name here" label="Last name" class="col-span-2 md:col-span-1" autocomplete="family-name" :required="true" v-model="inquiry.last_name" :error="errors.last_name && errors.last_name[0]" />
			<Input placeholder="Insert your email here" label="Email" class="col-span-2" autocomplete="email" :required="true" v-model="inquiry.email" :error="errors.email && errors.email[0]" />
			<Input placeholder="Insert your phone here" label="Phone" class="col-span-2" autocomplete="tel" v-model="inquiry.phone" :error="errors.phone && errors.phone[0]" />
			<Textarea placeholder="Insert your message here" label="Message" class="col-span-2" rows="10" v-model="inquiry.details" :error="errors.details && errors.details[0]" />
			<Button label="Send" class="primary col-span-2" type="submit" />
		</form>
	</section>
</template>
